import Ajax from '../js/common/ajax';

export default {
    getEnabled() {
        return Ajax.get('/advertisement/enabled')
    },
    getByPosition(position) {
        return Ajax.get(`/advertisement/position/${position}`)
    }
}